import { VALIDATION_MESSAGES, REGEX_PATTERNS } from 'eebac/constants';


const FIELDS = {
    boq: {
        type: "upload",
        label: "Upload BOQ",
        isRequired: false,
        onlyImage : false,
        showImageData :false,
        size: 1024,
        xs:12,
        lg:6,
        sm:6,
        md:6
    }
};

export default FIELDS;